import axios from "axios";

export type SequenceMemoItem = {
  memo: string;
  createdBy: string;
  createdAt: number;
  updatedBy: string;
  updatedAt: number;
};

//--> 시퀀스 디바큐잉 메모. { "동작콘텐츠id": { memo, 입력자/입력시간, 수정자/수정시간 } }
export const getSequenceMemo = async (programId: number) => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}api/public/sequencememo?programId=${programId}`,
    { withCredentials: true }
  );
  return response.data as { [contentsId: string]: SequenceMemoItem };
};

export const saveSequenceMemo = async (
  programId: number,
  contentsId: number,
  memo: string
) => {
  await axios.post(
    `${process.env.REACT_APP_SERVER_URL}api/admin/sequencememo`,
    { programId, contentsId, memo },
    { withCredentials: true }
  );
};
